import { Brand, Cuisine } from '@box-types';

export { getBrandsForCuisine };

function getBrandsForCuisine(cuisine: Cuisine, brands: Brand[]): Brand[] {
  if (!brands?.length) return [];
  if (!cuisine) return [];
  return brands.filter((brand) => brand.cuisine === cuisine._id);
}
